import { Form } from "@inertiajs/react"
import { useRef } from "react"
import { useTranslation } from "react-i18next"

import HeadingSmall from "@/components/heading-small"
import InputError from "@/components/input-error"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { usersPath } from "@/routes"

export default function DeleteUser() {
  const { t } = useTranslation()
  const passwordInput = useRef<HTMLInputElement>(null)

  return (
    <div className="space-y-6">
      <HeadingSmall
        title={t("settings.delete_account.title")}
        description={t("settings.delete_account.description")}
      />
      <div className="space-y-4 rounded-lg border border-red-100 bg-red-50 p-4 dark:border-red-200/10 dark:bg-red-700/10">
        <div className="relative space-y-0.5 text-red-600 dark:text-red-100">
          <p className="font-medium">{t("settings.delete_account.warning")}</p>
          <p className="text-sm">
            {t("settings.delete_account.warning_message")}
          </p>
        </div>

        <Dialog>
          <DialogTrigger asChild>
            <Button variant="destructive">
              {t("settings.delete_account.button")}
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogTitle>
              {t("settings.delete_account.confirm_title")}
            </DialogTitle>
            <DialogDescription>
              {t("settings.delete_account.confirm_description")}
            </DialogDescription>
            <Form
              method="delete"
              action={usersPath()}
              options={{
                preserveScroll: true,
              }}
              onError={() => passwordInput.current?.focus()}
              resetOnSuccess
              className="space-y-6"
            >
              {({ resetAndClearErrors, processing, errors }) => (
                <>
                  <div className="grid gap-2">
                    <Label htmlFor="password_challenge" className="sr-only">
                      {t("settings.password.current_password")}
                    </Label>

                    <Input
                      id="password_challenge"
                      type="password"
                      name="password_challenge"
                      ref={passwordInput}
                      placeholder={t("settings.password.current_password")}
                      autoComplete="current-password"
                    />

                    <InputError message={errors.password_challenge} />
                  </div>

                  <DialogFooter>
                    <DialogClose asChild>
                      <Button
                        variant="secondary"
                        onClick={() => resetAndClearErrors()}
                      >
                        {t("common.cancel")}
                      </Button>
                    </DialogClose>

                    <Button variant="destructive" disabled={processing} asChild>
                      <button type="submit">
                        {t("settings.delete_account.button")}
                      </button>
                    </Button>
                  </DialogFooter>
                </>
              )}
            </Form>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  )
}
